import { Suspense } from 'react';

import { Route, Switch } from 'react-router-dom';

import AccountHistory from '../../accountHistory/AccountHistory';
import ApplyFlexiLoanView from '../../applyFlexiLoanView/ApplyFlexiLoanView';
import { CBILSDashboard } from '../../CBILS/dashboard/Dashboard';
import SecondCBILSDashboard from '../../CBILS/secondCBILSDashboard/SecondCBILSDashboard';
import { Contracts } from '../../contracts/contracts';
import { CreditCard } from '../../creditCard/CreditCard';
import { Dashboard } from '../../dashboard/';
import EarlyRepayment from '../../earlyRepayment/EarlyRepayment';
import ConfirmFundingView from '../../funding/ConfirmFundingView/ConfirmFundingView';
import FundingRequirementsView from '../../funding/fundingRequirementsView/FundingReqirementsView';
import IwocapayDashboard from '../../iwocaPay/dashboard/Dashboard';
import { SellerDirecotry } from '../../iwocaPay/sellerDirectory/sellerDirectory';
import { MultiLoanDashboard } from '../../multiLoanDashboard/MultiLoanDashboard';
import MyOffers from '../../myOffers/MyOffers';
import { PageNotFound } from '../../pageNotFound/PageNotFound';
import Profile from '../../Profile/';
import RLSDashboard from '../../RLS/dashboard/Dashboard';
import { ApprovedPage } from '../../topupRequest/TopUpChoiceForm/Decision/Approved/ApprovedPage';
import { TopupRequest } from '../../topupRequest/TopupRequest';
import TradingData from '../../tradingData/TradingData';
import MainContentPending from '../mainContentPending';

const MainContent = () => (
    <Switch>
        <Route exact path="/">
            <Dashboard />;
        </Route>
        <Route path="/dashboard/:accountId">
            <Suspense fallback={<MainContentPending />}>
                <MultiLoanDashboard />
            </Suspense>
        </Route>
        <Route path="/approved/:accountId/">
            <ApprovedPage />
        </Route>
        <Route path="/apply-flexi-loan/">
            <ApplyFlexiLoanView />
        </Route>
        <Route path="/business-loan/">
            <div data-testid="term-loan-content">
                <Dashboard />
            </div>
        </Route>
        <Route path="/my-offers/">
            <MyOffers />
        </Route>
        <Route path="/funding-requirements/">
            <FundingRequirementsView />
        </Route>
        <Route path="/CBILS/">
            <CBILSDashboard />
        </Route>
        <Route path="/CBILS2/">
            <div data-testid="second-cbils-loan-content">
                <SecondCBILSDashboard />
            </div>
        </Route>
        <Route path="/confirm-funding/">
            <ConfirmFundingView />
        </Route>
        <Route path="/iwocapay/directory/">
            <SellerDirecotry />
        </Route>
        <Route path="/iwocapay/">
            <div data-testid="iwocapay-content">
                <IwocapayDashboard />
            </div>
        </Route>
        <Route path="/contracts/">
            <Contracts />
        </Route>
        <Route path="/history/">
            <AccountHistory />
        </Route>
        <Route path="/request-topup/">
            <TopupRequest />
        </Route>
        <Route path="/trading/">
            <TradingData />
        </Route>
        <Route path="/link-open-banking/">
            <TradingData />
        </Route>
        <Route path="/company/">
            <Profile />
        </Route>
        <Route path="/repayment/">
            <EarlyRepayment />
        </Route>
        <Route path="/recovery-loan-scheme/">
            <div data-testid="rls-content">
                <RLSDashboard />
            </div>
        </Route>
        <Route path="/credit-card">
            <CreditCard />
        </Route>
        <Route>
            <PageNotFound />
        </Route>
    </Switch>
);

// eslint-disable-next-line import/no-default-export
export default MainContent;
